import {Component, Input} from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
  selector: 'ls-spinner',
  standalone: true,
  templateUrl: './spinner.component.html',
  imports: [
    NgStyle
  ],
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  @Input() scale = 1;
}
